import TextThCell from './TextThCell';

export default TextThCell;
